<template>
    <cadastro-simples-form
        endpoint="tipo-distancia"
        rota-base="/admin/tipo-distancia"
        titulo-singular="Tipo de Distância"
        :campos-extras='[{"campo":"distancia_minima_km","label":"Distância mínima (km)","tipo":"string"},{"campo":"distancia_maxima_km","label":"Distância máxima (km)","tipo":"string"}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
